import styled from '@emotion/styled'
import { Container as StylistContainer, spacer, color } from 'stylist'

const Container = styled(StylistContainer)`
  & {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 1200px;
    grid-gap: ${spacer(4)};
  }
`

export const ResponsiveContainer = styled(Container)`
  @media (max-width: 1200px) {
    flex-direction: column;
  }
`

export const NoPadContainer = styled(Container)`
  & {
    padding: 0;
  }
`

export const ShadowedContainer = styled(Container)`
  border-radius: 3px;
  background-color: ${color('offWhite')};
  margin-top: ${spacer(2)};
  padding-top: ${spacer(5)};
  padding-bottom: ${spacer(5)};
`

export default Container



// WEBPACK FOOTER //
// ./src/components/Container.js